import _ from 'lodash'

// Utils
import eventUtils from '../../utils/eventUtils'
import { log } from '../../utils/logger'

// React Query
import queryClient from '../../queryClient'
import {
  PROJECTS_QUERY_KEY,
  ASSIGNMENTS_QUERY_KEY,
  TIMESHEETS_QUERY_KEY,
  TIME_OFF_ENTRIES_QUERY_KEY,
  TIME_OFF_CODES_QUERY_KEY,
  OUTLOOK_EVENTS_QUERY_KEY,
  OUTLOOK_EMAILS_QUERY_KEY,
  UNHANDLED_ENTRIES_QUERY_KEY,
} from '../../hooks/queries/keys'

export const updateViewOutlookEvents = async () => {
  await queryClient.invalidateQueries({ queryKey: OUTLOOK_EVENTS_QUERY_KEY })
}

export const updateViewOutlookEmails = async () => {
  await queryClient.invalidateQueries({ queryKey: OUTLOOK_EMAILS_QUERY_KEY })
}

export const updateViewTimesheets = async () => {
  await queryClient.invalidateQueries({ queryKey: TIMESHEETS_QUERY_KEY })
}

export const updateUnhandledEntries = ({ handleAppState }) => {
  const unhandledEntries = queryClient.getQueryData(UNHANDLED_ENTRIES_QUERY_KEY) ?? []
  const unhandledEntriesCount = _.size(unhandledEntries)
  log(`LS → UI → UnhandledEntry → ${unhandledEntriesCount}`)
  handleAppState({
    unhandledEntries: eventUtils.parseUnhandledEntries(unhandledEntries),
    unhandledEntriesInfo: eventUtils.parseUnhandledEntriesInfo(unhandledEntries),
  })
  return unhandledEntriesCount
}

export const updateViewTimeOffCodes = async () => {
  await queryClient.invalidateQueries({ queryKey: TIME_OFF_CODES_QUERY_KEY })
}

export const updateViewProjects = async () => {
  await queryClient.invalidateQueries({ queryKey: PROJECTS_QUERY_KEY })
}

export const updateViewAssignments = async () => {
  await queryClient.invalidateQueries({ queryKey: ASSIGNMENTS_QUERY_KEY })
}
